(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bm-announcement-rotator')) {
    class BmAnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bm-announcement__track');
        this.items = [...this.querySelectorAll('.bm-announcement__item:not([data-clone])')];
        this._current = 0;
        this._suspended = false;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.hasAttribute('autoplay') && !reduced && this.items.length > 1) this.play();
        this.addEventListener('mouseenter', () => this.stopTimer());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stopTimer());
        this.addEventListener('focusout', () => this.play());
      }

      disconnectedCallback() {
        this.stopTimer();
      }

      get current() {
        return this._current;
      }

      set current(index) {
        this.select(index, undefined, { animate: false });
      }

      play() {
        if (this._suspended || !this.hasAttribute('autoplay')) return;
        this.stopTimer();
        const interval = Number(this.dataset.interval) || 4000;
        this.timer = window.setInterval(() => this.select(this._current + 1), interval);
      }

      stopTimer() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      suspend() {
        this._suspended = true;
        this.stopTimer();
      }

      pause() {
        this.suspend();
      }

      select(index, _event, options = {}) {
        const total = this.items.length;
        if (!total || !this.track) return;
        const animate = options.animate !== false;
        const wrapsForward = index === total;
        const target = ((index % total) + total) % total;

        this.track.classList.toggle('is-animating', animate);
        this.track.style.setProperty('--bm-index', String(animate && wrapsForward ? total : target));
        this._current = target;
        this.items.forEach((item, i) => {
          const active = i === target;
          item.toggleAttribute('aria-hidden', !active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
          item.querySelectorAll('a').forEach((link) => (active ? link.removeAttribute('tabindex') : link.setAttribute('tabindex', '-1')));
        });

        if (animate && wrapsForward) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.track.classList.remove('is-animating');
              this.track.style.setProperty('--bm-index', '0');
            },
            { once: true }
          );
        }
      }
    }

    customElements.define('bm-announcement-rotator', BmAnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-collection"]) return;
  try {
    
  if (!customElements.get('bm-collection')) {
    const VIEW_KEY = 'bm-plp-view';
    const root = document.documentElement;

    const readView = () => {
      try {
        return sessionStorage.getItem(VIEW_KEY) || 'default';
      } catch (error) {
        return 'default';
      }
    };

    const applyView = (view) => {
      if (view === 'default') root.removeAttribute('data-bm-plp-view');
      else root.setAttribute('data-bm-plp-view', view);
    };

    applyView(readView());

    /* Clave estable de un grupo del panel de filtros (el id del contenido, también en el de precio) */
    const groupKey = (details) => details.querySelector('[id^="facet-inputs-"]')?.id || details.id;

    class BmCollection extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDrawerOpen = this.onDrawerOpen.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        document.addEventListener('theme-drawer:open', this.onDrawerOpen);
        document.addEventListener('theme-drawer:close', this.onDrawerClose);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        /* Sólo cierra si el foco pasa a otro control (Tab): tocar el velo o la hoja deja el foco en <body>
           y el click (cerrar y volver al botón) lo resuelve onClick */
        this.addEventListener('focusout', (event) => {
          if (event.target.closest('[data-bm-sort]') && event.relatedTarget && !event.relatedTarget.closest('[data-bm-sort]')) this.setSortOpen(false);
        });
        document.addEventListener('click', this.onDocumentClick);
        /* Estado del panel de filtros antes de que Horizon lo vuelva a dibujar (ver keepFiltersOpen) */
        this.addEventListener('focusin', (event) => {
          if (event.target.closest('#filters-drawer')) this.filtersFocus = event.target.id || null;
        });
        const snapshotGroups = (event) => {
          const drawer = event.target.closest?.('#filters-drawer');
          if (drawer) this.filtersGroups = new Set([...drawer.querySelectorAll('details.facets__panel[open]')].map(groupKey));
        };
        this.addEventListener('change', snapshotGroups, true);
        this.addEventListener('click', snapshotGroups, true);
        this.syncViews();
        this.enhancePrice();
        this.restorePages();
        this.observeMore();
        this.resizeObserver = new ResizeObserver(() => {
          this.syncFilterButton();
        });
        this.resizeObserver.observe(this);
        /* Filtrar flotante: se esconde al terminar el listado y, en mobile, al bajar (ver el CSS). El scroll de la
           página llega en captura: en desktop scrollea .page-wrapper (Horizon) y en mobile el documento */
        this.onPageScroll = this.onPageScroll.bind(this);
        document.addEventListener('scroll', this.onPageScroll, { capture: true, passive: true });
        this.syncFilterButton();
        /* Al filtrar, Horizon vuelve a dibujar la sección: se resincronizan los botones de vista */
        this.observer = new MutationObserver(() => {
          this.syncViews();
          this.keepFiltersOpen();
          this.enhancePrice();
          this.observeMore();
          this.syncFilterButton();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('theme-drawer:open', this.onDrawerOpen);
        document.removeEventListener('theme-drawer:close', this.onDrawerClose);
        document.removeEventListener('scroll', this.onPageScroll, { capture: true });
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }

      /* Sólo el scroll de la página: los carruseles, las subcategorías y los paneles scrollean adentro y no cuentan */
      onPageScroll(event) {
        const target = event.target === document ? document.scrollingElement : event.target;
        if (target !== document.scrollingElement && !target.classList?.contains('page-wrapper')) return;
        this.scroller = target;
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.syncFilterButton();
        });
      }

      /* data-bm-away: el final del listado ya pasó por arriba del botón (debajo vienen el texto SEO, los servicios y
         el footer). data-bm-down: se está bajando; al subir (o arriba de todo) vuelve. Con menos de 4 px entre dos
         cuadros se deja como estaba, para que un temblor del dedo no lo haga parpadear */
      syncFilterButton() {
        const button = this.querySelector('.bm-filter-button');
        if (!button) return;
        const scroller = this.scroller || document.scrollingElement;
        const top = scroller.scrollTop;
        const delta = top - (this.lastScrollTop ?? top);
        this.lastScrollTop = top;
        if (top <= 0) this.scrollingDown = false;
        else if (Math.abs(delta) >= 4) this.scrollingDown = delta > 0;

        const buttonBottom = window.innerHeight - (parseFloat(getComputedStyle(button).bottom) || 0);
        button.toggleAttribute('data-bm-away', this.getBoundingClientRect().bottom < buttonBottom);
        button.toggleAttribute('data-bm-down', Boolean(this.scrollingDown));
      }

      syncViews() {
        const view = readView();
        this.querySelectorAll('[data-bm-view]').forEach((button) => {
          const pressed = String(button.dataset.bmView === view);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        });
      }

      /* El Figma abre el panel con los grupos cerrados (49 px); Horizon los dibuja [open] en el drawer.
         Se cierran los que no tienen un filtro aplicado: los activos quedan a la vista. Sólo al abrirlo: con
         el panel ya abierto (Filtrar queda encima del velo) Horizon lo trae al frente y vuelve a avisar */
      onDrawerOpen(event) {
        if (event.target.id !== 'filters-drawer' || !this.contains(event.target)) return;
        if (!this.filtersOpen) {
          this.querySelectorAll('#filters-drawer details.facets__panel[open]').forEach((details) => {
            /* Los range del slider de precio siempre tienen valor: cuentan sólo los campos de Horizon */
            const active = [...details.querySelectorAll('input:not(.bm-price__input)')].some((input) =>
              input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value !== ''
            );
            if (!active) details.open = false;
          });
        }
        this.filtersOpen = true;
      }

      onDrawerClose(event) {
        if (event.target.id === 'filters-drawer') this.filtersOpen = false;
      }

      /* Al filtrar, Horizon vuelve a pedir la sección y el morph cambia el <theme-drawer> por uno nuevo, cerrado,
         sin avisar el cierre (≥ 990 .page-wrapper quedaba angosta). Si el panel estaba abierto se vuelve a abrir
         al instante, con los mismos grupos abiertos y el foco en el control que se tocó */
      keepFiltersOpen() {
        const drawer = this.querySelector('#filters-drawer');
        const panel = drawer?.querySelector('dialog');
        if (!this.filtersOpen || !panel || typeof drawer.open !== 'function') return;
        if (drawer.hasAttribute('open') && panel.open) return;

        if (this.filtersGroups) {
          drawer.querySelectorAll('details.facets__panel').forEach((details) => {
            details.open = this.filtersGroups.has(groupKey(details));
          });
        }
        /* open() pasa el foco a la X: el control que se tocó se busca antes. Y guarda dónde estaba el foco para
           devolverlo al cerrar: se le da a Filtrar, que es quien abrió el panel */
        const target = this.filtersFocus && document.getElementById(this.filtersFocus);
        this.querySelector('.bm-filter-button')?.focus({ preventScroll: true });
        drawer.removeAttribute('open');
        panel.classList.add('theme-drawer__dialog-instant');
        drawer.open();
        panel.classList.remove('theme-drawer__dialog--opening');
        requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove('theme-drawer__dialog-instant')));
        if (target && drawer.contains(target)) target.focus({ preventScroll: true });
      }

      onClick(event) {
        /* Clic en el velo propio del panel de filtros (≥ 990): cierra como el backdrop de Horizon */
        if (event.target.classList.contains('bm-plp__facets')) {
          this.querySelector('#filters-drawer')?.close?.();
          return;
        }

        const viewButton = event.target.closest('[data-bm-view]');
        if (viewButton) {
          const view = viewButton.dataset.bmView;
          try {
            sessionStorage.setItem(VIEW_KEY, view);
          } catch (error) {}
          applyView(view);
          this.syncViews();
          return;
        }

        if (event.target.closest('[data-bm-sort-close]')) {
          this.setSortOpen(false);
          this.querySelector('[data-bm-sort-toggle]')?.focus();
          return;
        }

        const toggle = event.target.closest('[data-bm-sort-toggle]');
        if (toggle) {
          this.setSortOpen(toggle.getAttribute('aria-expanded') !== 'true');
          return;
        }

        const option = event.target.closest('[data-sort]');
        if (option) {
          event.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', option.dataset.sort);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
          return;
        }

        const more = event.target.closest('[data-bm-more]');
        if (more) {
          event.preventDefault();
          this.loadMore(more);
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const toggle = this.querySelector('[data-bm-sort-toggle]');
        if (toggle?.getAttribute('aria-expanded') === 'true') {
          event.stopPropagation();
          this.setSortOpen(false);
          toggle.focus();
        }
      }

      onDocumentClick(event) {
        if (!event.target.closest('[data-bm-sort]')) this.setSortOpen(false);
      }

      setSortOpen(open) {
        const toggle = this.querySelector('[data-bm-sort-toggle]');
        const list = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
        if (!toggle || !list) return;
        toggle.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
        if (open) {
          (list.querySelector('[aria-current]') || list.querySelector('a'))?.focus();
        }
      }

      /* Filtro de precio del Figma: dos sliders sobre un riel en lugar de los campos de Horizon (ocultos, siguen en
         el form). Cada movimiento se copia a esos campos en el 'input', antes del 'change' que Horizon escucha en
         captura (en document) para filtrar. El slider va al final de price-facet-component (order -1 lo sube): así el
         morph de Horizon no lo confunde con sus nodos (le pisaba el value y el «desde» volvía a la mitad del rango) y
         sólo lo saca; se vuelve a armar con los valores de la respuesta y, si tenía el foco, lo recupera */
      enhancePrice() {
        const facet = this.querySelector('#filters-drawer price-facet-component');
        const max = Number(this.dataset.bmPriceMax);
        if (!facet || !max) return;
        const minInput = facet.querySelector('[ref="minInput"]');
        const maxInput = facet.querySelector('[ref="maxInput"]');
        if (!minInput || !maxInput) return;

        const step = Math.max(1, Math.round(max / 100));
        const top = Math.ceil(max / step) * step;
        const from = Math.min(Number(this.dataset.bmPriceFrom) || 0, top);
        const to = Math.min(Number(this.dataset.bmPriceTo) || top, top);
        const key = `${top}:${from}:${to}`;
        let wrapper = facet.querySelector('.bm-price');
        if (wrapper?.dataset.key === key) return;
        wrapper?.remove();

        const format = (value) => `${this.dataset.bmPriceSymbol || '$'}${Math.round(value).toLocaleString('es-AR')}`;
        wrapper = document.createElement('div');
        wrapper.className = 'bm-price';
        wrapper.dataset.key = key;
        wrapper.innerHTML = `<div class="bm-price__values"><span data-bm-price-label="from"></span><span data-bm-price-label="to"></span></div>
          <div class="bm-price__range">
            <input type="range" class="bm-price__input" data-bm-price="from" min="0" max="${top}" step="1" value="${from}">
            <input type="range" class="bm-price__input" data-bm-price="to" min="0" max="${top}" step="1" value="${to}">
          </div>`;
        const [fromRange, toRange] = wrapper.querySelectorAll('input');
        fromRange.setAttribute('aria-label', minInput.getAttribute('aria-label') || '');
        toRange.setAttribute('aria-label', maxInput.getAttribute('aria-label') || '');

        const paint = () => {
          wrapper.querySelector('[data-bm-price-label="from"]').textContent = format(Number(fromRange.value));
          wrapper.querySelector('[data-bm-price-label="to"]').textContent = format(Number(toRange.value) >= top ? max : Number(toRange.value));
          fromRange.setAttribute('aria-valuetext', format(Number(fromRange.value)));
          toRange.setAttribute('aria-valuetext', format(Number(toRange.value)));
          const range = wrapper.querySelector('.bm-price__range');
          range.style.setProperty('--bm-from', String(Number(fromRange.value) / top));
          range.style.setProperty('--bm-to', String(Number(toRange.value) / top));
        };

        /* Sólo cambia el extremo que se mueve: el otro queda con lo aplicado (o vacío = sin límite) */
        const sync = () => {
          minInput.value = Number(fromRange.value) > 0 ? fromRange.value : '';
          maxInput.value = Number(toRange.value) < top ? toRange.value : '';
        };

        /* El range va de a 1 para mostrar exacto lo aplicado ($20.000, no $20.250); al arrastrar se redondea al paso */
        wrapper.addEventListener('input', (event) => {
          if (event.target === fromRange || event.target === toRange) {
            event.target.value = String(Math.min(Math.round(Number(event.target.value) / step) * step, top));
          }
          /* Los tiradores no se cruzan */
          if (event.target === fromRange && Number(fromRange.value) > Number(toRange.value)) fromRange.value = toRange.value;
          if (event.target === toRange && Number(toRange.value) < Number(fromRange.value)) toRange.value = fromRange.value;
          paint();
          sync();
        });

        /* Teclado: se mueve y se pinta en cada tecla, pero se filtra una sola vez cuando se deja de tocar */
        let commit;
        wrapper.addEventListener('keydown', (event) => {
          const range = event.target;
          if (range !== fromRange && range !== toRange) return;
          const delta = { ArrowRight: step, ArrowUp: step, ArrowLeft: -step, ArrowDown: -step, PageUp: step * 10, PageDown: -step * 10 }[event.key];
          const edge = { Home: 0, End: top }[event.key];
          if (delta === undefined && edge === undefined) return;
          event.preventDefault();
          const low = range === toRange ? Number(fromRange.value) : 0;
          const high = range === fromRange ? Number(toRange.value) : top;
          range.value = String(Math.min(Math.max(edge ?? Number(range.value) + delta, low), high));
          paint();
          sync();
          clearTimeout(commit);
          commit = setTimeout(() => range.dispatchEvent(new Event('change', { bubbles: true })), 600);
        });

        wrapper.addEventListener('focusin', (event) => {
          this.priceFocus = event.target.dataset.bmPrice;
        });
        wrapper.addEventListener('focusout', (event) => {
          if (event.relatedTarget) this.priceFocus = null;
        });

        paint();
        facet.append(wrapper);
        if (this.priceFocus) wrapper.querySelector(`[data-bm-price="${this.priceFocus}"]`)?.focus({ preventScroll: true });
      }

      /* Trae una página de la grilla y la agrega; devuelve los productos nuevos */
      async appendPage(button, href) {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(String(response.status));
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = this.querySelector('[data-bm-grid]');
        const items = [...html.querySelectorAll('[data-bm-item]')].map((item) => document.importNode(item, true));
        grid.append(...items);

        const next = html.querySelector('[data-bm-more]');
        const status = this.querySelector('[data-bm-more-status]');
        /* Con colores abiertos hay varias cards por producto: el estado cuenta productos, como el total */
        const shown = new Set([...grid.querySelectorAll('[data-bm-item]')].map((item) => item.dataset.bmProduct || item)).size;
        if (next) {
          button.href = next.getAttribute('href');
          button.removeAttribute('aria-busy');
          const nextStatus = html.querySelector('[data-bm-more-status]');
          if (status && nextStatus) status.textContent = nextStatus.textContent.replace(/\d+/, String(shown));
        } else {
          button.closest('.bm-plp__more')?.remove();
        }
        return items;
      }

      async loadMore(button, auto = false) {
        if (button.getAttribute('aria-busy') === 'true' || (auto && this.restoring)) return;
        button.setAttribute('aria-busy', 'true');
        const href = button.href;

        try {
          const items = await this.appendPage(button, href);
          /* Las páginas cargadas quedan en la entrada del historial: al volver de una ficha se vuelven a traer */
          try {
            const state = history.state && typeof history.state === 'object' ? history.state : {};
            history.replaceState({ ...state, bmPlpPages: [...(state.bmPlpPages || []), href] }, '');
          } catch (error) {}
          /* El foco pasa al primer producto nuevo para seguir recorriendo con teclado (con el click, no al scrollear) */
          if (!auto) items[0]?.querySelector('a[href]:not([tabindex="-1"])')?.focus({ preventScroll: true });
          this.observeMore(true);
        } catch (error) {
          if (auto) {
            /* Con error al scrollear no se navega: queda el botón «Ver más» para reintentar */
            button.removeAttribute('aria-busy');
            this.moreObserver?.disconnect();
            return;
          }
          /* Sin JS o con error, el enlace lleva a la página siguiente */
          window.location.assign(href);
        }
      }

      /* Scroll infinito: cuando «Ver más» se acerca al borde de la pantalla, se trae la página siguiente. El botón
         queda como respaldo (sin JS, o si falla). Se vuelve a observar después de cada página: si el botón sigue a la
         vista (pantallas altas), el observer no avisaría otra vez sin un cambio de intersección. */
      observeMore(force = false) {
        if (!this.hasAttribute('data-bm-infinite') || !('IntersectionObserver' in window)) return;
        const more = this.querySelector('.bm-plp__more');
        if (!force && more === this.moreTarget) return;
        this.moreObserver?.disconnect();
        this.moreTarget = more;
        if (!more) return;
        this.moreObserver ??= new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          const button = this.querySelector('[data-bm-more]');
          if (button) this.loadMore(button, true);
        }, { rootMargin: '0px 0px 800px 0px' });
        this.moreObserver.observe(more);
      }

      /* Volver (o recargar) con «Ver más» usado: se agregan las mismas páginas y se repone la posición que
         Horizon guardó en history.state (sin esos productos la recortaba al alto de la primera página) */
      async restorePages() {
        const pages = history.state?.bmPlpPages;
        const button = this.querySelector('[data-bm-more]');
        if (!Array.isArray(pages) || !pages.length || !button) return;
        button.setAttribute('aria-busy', 'true');
        this.restoring = true;
        try {
          for (const href of pages) {
            await this.appendPage(button, href);
            if (!button.isConnected) break;
          }
        } catch (error) {
          button.removeAttribute('aria-busy');
          return;
        } finally {
          this.restoring = false;
        }
        const scrollTop = history.state?.scrollTop;
        if (!Number.isFinite(scrollTop)) return;
        const wrapper = document.querySelector('.page-wrapper');
        const scroller = window.matchMedia('(min-width: 990px)').matches && wrapper ? wrapper : document.scrollingElement;
        requestAnimationFrame(() => scroller?.scrollTo({ top: scrollTop, behavior: 'instant' }));
      }
    }

    customElements.define('bm-collection', BmCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-community"] && !Shopify.designMode) return;
  try {
    
  /* Comunidad: la foto abre el post en grande (dialog nativo); flechas y ← → pasan al anterior o al siguiente, en
     ronda. Delegado en document: sobrevive al re-render de la sección en el editor. */
  if (!window.bmCommunity) {
    window.bmCommunity = true;

    /**
     * @param {HTMLDialogElement} dialog
     * @param {number} index
     */
    const showPost = (dialog, index) => {
      const slides = dialog.querySelectorAll('[data-bm-post-slide]');
      if (!slides.length) return;
      const current = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        if (slide instanceof HTMLElement) slide.hidden = position !== current;
      });
      dialog.dataset.index = String(current);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const opener = event.target.closest('[data-bm-post-open]');
      if (opener) {
        const dialog = document.getElementById(opener.getAttribute('aria-controls') || '');
        if (!(dialog instanceof HTMLDialogElement)) return;
        showPost(dialog, Number(opener.getAttribute('data-bm-post-open')) || 0);
        if (!dialog.open) dialog.showModal();
        return;
      }

      const dialog = event.target.closest('dialog.bm-post');
      if (!(dialog instanceof HTMLDialogElement)) return;

      /* El contenido llena la ventana: un clic sobre el dialog mismo es el velo */
      if (event.target === dialog || event.target.closest('[data-bm-post-close]')) {
        dialog.close();
        return;
      }

      const step = event.target.closest('[data-bm-post-step]');
      if (step) showPost(dialog, Number(dialog.dataset.index || 0) + Number(step.getAttribute('data-bm-post-step')));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const dialog = document.querySelector('dialog.bm-post[open]');
      if (!(dialog instanceof HTMLDialogElement)) return;
      event.preventDefault();
      showPost(dialog, Number(dialog.dataset.index || 0) + (event.key === 'ArrowRight' ? 1 : -1));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bm-footer__toggle').forEach((toggle) => {
      if (toggle.dataset.bmReady) return;
      toggle.dataset.bmReady = 'true';
      toggle.addEventListener('click', () => {
        const column = toggle.closest('.bm-footer__column');
        const open = !column.classList.contains('is-open');
        // Como el Figma (Footer · Abierta=<columna>): abrir una cierra la que estaba abierta
        if (open) {
          column.parentElement.querySelectorAll('.bm-footer__column.is-open').forEach((other) => {
            other.classList.remove('is-open');
            other.querySelector('.bm-footer__toggle')?.setAttribute('aria-expanded', 'false');
          });
        }
        column.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
    document.querySelectorAll('[data-bm-autosubmit]').forEach((select) => {
      select.addEventListener('change', () => select.form?.submit());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-bm-header]');
    if (!header || header.dataset.bmReady) return;
    header.dataset.bmReady = 'true';

    /* Transparente sobre el hero hasta la marca «cambio-header» */
    const updateState = () => {
      const overlay = document.querySelector('[data-bm-overlay-header]');
      if (!overlay) {
        header.classList.remove('is-transparent');
        return;
      }
      const marker = document.querySelector('[data-section="cambio-header"]') || overlay;
      const headerBottom = header.getBoundingClientRect().bottom;
      const markerRect = marker.getBoundingClientRect();
      const limit = marker === overlay ? markerRect.bottom : markerRect.top;
      header.classList.toggle('is-transparent', limit > headerBottom);
    };
    updateState();
    document.addEventListener('scroll', updateState, { capture: true, passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    document.addEventListener('shopify:section:load', updateState);

    /* Megamenú: se abre al entrar con el mouse (o con el foco) en una sección con hijos y muestra esa pestaña.
       Se cierra con la cruz, Escape, al mover el mouse sobre el velo (la zona de cierre), al hacer clic en un link o si el foco sale */
    const mega = header.querySelector('[data-bm-mega]');
    const nav = header.querySelector('.bm-header__nav');
    if (mega && nav) {
      const openers = header.querySelectorAll('[data-bm-mega-open]');
      const tabs = mega.querySelectorAll('[data-bm-mega-tab]');
      let opener = null;
      /* Después de Escape (o de Shift+Tab desde la primera pestaña) el foco vuelve al link del header sin reabrir
         el panel; Tab a otro link del menú sí abre el suyo */
      let suppressed = null;
      /* Con el puntero sobre el panel, al cerrarlo con Escape queda encima de un link del menú y Chrome dispara
         mouseenter sin que se mueva: no se reabre hasta que el puntero se mueva de verdad (QA arriba-23) */
      let hoverBlocked = false;

      let current = null;

      const show = (index) => {
        current = index;
        mega.querySelectorAll('[data-bm-mega-content]').forEach((element) => {
          element.hidden = element.dataset.bmMegaContent !== index;
        });
        tabs.forEach((tab) => tab.classList.toggle('is-current', tab.dataset.bmMegaTab === index));
      };

      /* Entrada del panel (transform 0,3 s): el velo no lo cierra hasta que termina */
      const OPENING_MS = 300;
      let openedAt = 0;

      /* Pestañas del panel sobre los links del header: el renglón del texto (caja del link menos su padding) y el x del
         primero, medidos contra .bm-mega (fijo, a pantalla completa). Cambia con la barra de anuncios a la vista o no */
      const firstLink = nav.querySelector('.bm-nav__link');
      const align = () => {
        if (!(firstLink instanceof HTMLElement)) return;
        const box = mega.getBoundingClientRect();
        const rect = firstLink.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(firstLink).paddingTop) || 0;
        mega.style.setProperty('--bm-mega-top', `${Math.round(rect.top - box.top + padding)}px`);
        mega.style.setProperty('--bm-mega-left', `${Math.round(rect.left - box.left)}px`);
        mega.style.setProperty('--bm-mega-reach', `${padding}px`);
      };

      const open = (link) => {
        align();
        show(link.dataset.bmMegaOpen);
        opener = link;
        openers.forEach((item) => item.setAttribute('aria-expanded', String(item === link)));
        if (!mega.classList.contains('is-open')) openedAt = performance.now();
        mega.classList.add('is-open');
      };

      const close = (returnFocus) => {
        if (!mega.classList.contains('is-open')) return;
        mega.classList.remove('is-open');
        openers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
        const target = header.querySelector(`[data-bm-mega-open="${current}"]`) || opener;
        if (returnFocus && target) {
          suppressed = target;
          target.focus({ preventScroll: true });
        }
      };

      openers.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          if (!hoverBlocked) open(link);
        });
        /* Con teclado el panel tapa el link: el foco pasa a la misma pestaña dentro del panel */
        link.addEventListener('focus', () => {
          if (link === suppressed || !link.matches(':focus-visible')) return;
          suppressed = null;
          open(link);
          mega.querySelector(`[data-bm-mega-tab="${link.dataset.bmMegaOpen}"]`)?.focus({ preventScroll: true });
        });
      });
      tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => show(tab.dataset.bmMegaTab));
        tab.addEventListener('focus', () => show(tab.dataset.bmMegaTab));
      });
      /* El velo cubre toda la pantalla: mientras el panel entra (0,3 s) queda bajo el puntero, que sigue sobre el
         link del menú, y Chrome le dispara mouseenter sin que el mouse se mueva: se cerraba y se volvía a abrir en
         loop (QA arriba-12). Ahora cierra sólo un movimiento real sobre el velo y nunca durante la entrada */
      const veil = mega.querySelector('[data-bm-mega-veil]');
      veil?.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || !(event.movementX || event.movementY)) return;
        if (performance.now() - openedAt < OPENING_MS) return;
        close(false);
      }, { passive: true });
      veil?.addEventListener('click', () => close(false));
      mega.querySelector('[data-bm-mega-close]')?.addEventListener('click', () => close(true));
      mega.addEventListener('click', (event) => {
        if (event.target.closest('a')) close(false);
      });
      mega.addEventListener('focusout', (event) => {
        const next = event.relatedTarget instanceof Node ? event.relatedTarget : null;
        if (!next || !mega.contains(next)) close(false);
      });
      mega.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !event.shiftKey || event.target !== mega.querySelector('.bm-mega__tab')) return;
        event.preventDefault();
        const first = nav.querySelector('.bm-nav__link');
        suppressed = first;
        close(false);
        first?.focus({ preventScroll: true });
      });
      nav.addEventListener('focusout', (event) => {
        const next = event.relatedTarget instanceof Node ? event.relatedTarget : null;
        if (!next || !nav.contains(next)) suppressed = null;
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !mega.classList.contains('is-open')) return;
        hoverBlocked = true;
        close(mega.contains(document.activeElement));
      });
      document.addEventListener('pointermove', (event) => {
        if (event.movementX || event.movementY) hoverBlocked = false;
      }, { passive: true });
      /* Con el panel abierto la página puede scrollear (rueda sobre el velo) y el header moverse: se vuelve a alinear */
      const realign = () => {
        if (mega.classList.contains('is-open')) align();
      };
      document.addEventListener('scroll', realign, { capture: true, passive: true });
      window.addEventListener('resize', realign, { passive: true });
    }

    /* Drawer mobile: <dialog> nativo (Escape y foco de vuelta los da el navegador); las pestañas muestran su lista */
    const drawer = header.querySelector('#BmMenuDrawer');
    const drawerOpener = header.querySelector('[data-bm-drawer-open]');
    if (drawer && drawerOpener) {
      /* Sale hacia la izquierda (.bm-drawer--closing) y recién al terminar se cierra el dialog. Sin animación
         (movimiento reducido) cierra en el acto; si el navegador lo cierra antes (Escape repetido), la animación
         se cancela y también termina */
      const closeDrawer = () => {
        if (!drawer.open || drawer.classList.contains('bm-drawer--closing')) return;
        drawer.classList.add('bm-drawer--closing');
        const animations = typeof drawer.getAnimations === 'function' ? drawer.getAnimations() : [];
        Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
          drawer.classList.remove('bm-drawer--closing');
          drawer.close();
        });
      };
      drawerOpener.addEventListener('click', () => {
        drawer.showModal();
        drawerOpener.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('close', () => {
        drawer.classList.remove('bm-drawer--closing');
        drawerOpener.setAttribute('aria-expanded', 'false');
      });
      drawer.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDrawer();
      });
      drawer.querySelector('[data-bm-drawer-close]')?.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer || event.target.closest('a')) closeDrawer();
      });
      const drawerTabs = drawer.querySelectorAll('[data-bm-drawer-tab]');
      drawerTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          drawerTabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-expanded', String(selected));
            const panel = drawer.querySelector(`#${item.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !selected;
          });
        });
      });
    }

    /* Buscador (snippets/bm-search-panel). Al limpiar la búsqueda (cruz, Escape, cerrar) Horizon pone en el
       contenedor de resultados su propio vacío (sections/predictive-search-empty) o, con productos vistos, deja los
       resultados viejos. Acá el vacío es el del panel: el contenedor se vacía, porque el teclado de Horizon (Tab,
       flechas) recorría esas cards ocultas */
    const searchPanel = document.querySelector('[data-bm-search-panel]');
    const searchInput = searchPanel?.querySelector('[data-bm-search-input]');
    const searchSlot = searchPanel?.querySelector('[data-bm-search-slot]');
    if (searchPanel && searchInput && searchSlot && !searchPanel.dataset.bmReady) {
      searchPanel.dataset.bmReady = 'true';
      let lastTerms = null;

      const clearResults = () => {
        lastTerms = null;
        if (searchSlot.firstElementChild) searchSlot.replaceChildren();
      };

      const syncResults = () => {
        const results = searchSlot.querySelector('[data-bm-search-results]');
        if (!searchInput.value.trim() || !results) {
          clearResults();
          return;
        }
        /* Búsqueda nueva: la lista y el carrusel vuelven al principio y las flechas se recalculan */
        if (results.dataset.bmTerms !== lastTerms) {
          lastTerms = results.dataset.bmTerms;
          searchPanel.querySelector('.bm-search-panel__body')?.scrollTo(0, 0);
          searchSlot.querySelectorAll('[data-bm-viewport]').forEach((viewport) => {
            viewport.scrollLeft = 0;
          });
        }
        searchSlot.querySelectorAll('bm-scroller').forEach((scroller) => scroller.update?.());
      };

      let frame = 0;
      const scheduleSync = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          syncResults();
        });
      };

      new MutationObserver(scheduleSync).observe(searchSlot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-bm-terms'],
      });
      searchInput.addEventListener('input', scheduleSync);
      searchPanel.querySelector('[data-bm-search-clear]')?.addEventListener('click', clearResults);
      searchPanel.addEventListener('dialog:close', clearResults);
    }

    /* El carrito se abre sólo al agregar o con el ícono, nunca al volver a una página: si el bfcache la trae con el
       cajón abierto («atrás» en Safari o Firefox), se cierra sin la animación de salida. Lo guardado en sessionStorage
       ya no lo reabre (no-persist en snippets/cart-drawer). */
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      const drawer = /** @type {any} */ (document.getElementById('cart-drawer'));
      if (!drawer?.hasAttribute('open') || typeof drawer.close !== 'function') return;
      const panel = drawer.querySelector('dialog');
      panel?.classList.add('theme-drawer__dialog-instant');
      Promise.resolve(drawer.close()).finally(() => panel?.classList.remove('theme-drawer__dialog-instant'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-search"]) return;
  try {
    
  if (!customElements.get('bm-search')) {
    /* La vista elegida es la misma que la del listado (PLP): misma clave y mismo atributo en <html> */
    const VIEW_KEY = 'bm-plp-view';
    const root = document.documentElement;

    const readView = () => {
      try {
        return sessionStorage.getItem(VIEW_KEY) || 'default';
      } catch (error) {
        return 'default';
      }
    };

    const applyView = (view) => {
      if (view === 'default') root.removeAttribute('data-bm-plp-view');
      else root.setAttribute('data-bm-plp-view', view);
    };

    applyView(readView());

    const groupKey = (details) => details.querySelector('[id^="facet-inputs-"]')?.id || details.id;

    class BmSearch extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDrawerOpen = this.onDrawerOpen.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('theme-drawer:open', this.onDrawerOpen);
        document.addEventListener('theme-drawer:close', this.onDrawerClose);
        this.addEventListener('focusout', (event) => {
          if (event.target.closest('[data-bm-sort]') && event.relatedTarget && !event.relatedTarget.closest('[data-bm-sort]')) this.setSortOpen(false);
        });

        /* Los filtros de Horizon arman la URL con los campos de su formulario (q y filtros): se suman type=product
           (la búsqueda es sólo de productos) y el orden elegido, que no están en ese formulario */
        this.addEventListener('formdata', (event) => {
          if (!event.target.closest?.('#filters-drawer, facets-form-component')) return;
          event.formData.set('type', 'product');
          const sort = new URL(window.location.href).searchParams.get('sort_by');
          if (sort && !event.formData.has('sort_by')) event.formData.set('sort_by', sort);
        });

        /* Estado del panel de filtros antes de que Horizon vuelva a dibujar la sección (ver keepFiltersOpen) */
        this.addEventListener('focusin', (event) => {
          if (event.target.closest('#filters-drawer')) this.filtersFocus = event.target.id || null;
        });
        const snapshotGroups = (event) => {
          const drawer = event.target.closest?.('#filters-drawer');
          if (drawer) this.filtersGroups = new Set([...drawer.querySelectorAll('details.facets__panel[open]')].map(groupKey));
        };
        this.addEventListener('change', snapshotGroups, true);
        this.addEventListener('click', snapshotGroups, true);

        this.syncViews();
        this.syncSectionName();
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onMediaChange = () => this.syncSectionName();
        this.mobileQuery.addEventListener?.('change', this.onMediaChange);
        this.loadPages();
        this.watchLoading();

        /* Al filtrar, Horizon vuelve a dibujar la sección (morph): se resincroniza lo que arma el JS */
        this.observer = new MutationObserver(() => {
          this.syncViews();
          this.syncSectionName();
          this.fillPages();
          this.watchLoading();
          this.keepFiltersOpen();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('theme-drawer:open', this.onDrawerOpen);
        document.removeEventListener('theme-drawer:close', this.onDrawerClose);
        this.observer?.disconnect();
        this.loadingObserver?.disconnect();
        this.mobileQuery?.removeEventListener?.('change', this.onMediaChange);
      }

      /* La barra es «barra» en desktop y «fila-de-vistas» en mobile (nombres del Figma) */
      syncSectionName() {
        const bar = this.querySelector('[data-bm-section-mobile]');
        if (!bar) return;
        const name = window.matchMedia('(max-width: 749px)').matches ? bar.dataset.bmSectionMobile : 'barra';
        if (bar.dataset.section !== name) bar.dataset.section = name;
      }

      syncViews() {
        const view = readView();
        this.querySelectorAll('[data-bm-view]').forEach((button) => {
          const pressed = String(button.dataset.bmView === view);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        });
      }

      /* Páginas que coinciden con el término: buscador predictivo de Shopify, aparte de los productos */
      async loadPages() {
        const terms = this.dataset.terms;
        if (!terms || !this.querySelector('[data-bm-pages]')) return;
        try {
          const url = new URL(window.Theme?.routes?.predictive_search_url || '/search/suggest', window.location.origin);
          url.searchParams.set('q', terms);
          url.searchParams.set('resources[type]', 'page');
          url.searchParams.set('resources[limit]', this.dataset.pagesLimit || '2');
          url.searchParams.set('section_id', 'bm-search-pages');
          const response = await fetch(url.toString());
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          this.pagesContent = html.querySelector('[data-bm-search-pages-content]');
          this.fillPages();
        } catch (error) {}
      }

      fillPages() {
        const wrapper = this.querySelector('[data-bm-pages]');
        const list = wrapper?.querySelector('[data-bm-pages-list]');
        if (!list || !this.pagesContent || list.firstElementChild) return;
        list.append(document.importNode(this.pagesContent, true));
        wrapper.hidden = false;
      }

      /* Carga infinita: «CARGANDO...» trae la página siguiente cuando se acerca a la vista */
      watchLoading() {
        const loading = this.querySelector('[data-bm-loading]');
        if (loading === this.loadingTarget) return;
        this.loadingObserver?.disconnect();
        this.loadingTarget = loading;
        if (!loading || !('IntersectionObserver' in window)) return;
        this.loadingObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
        }, { rootMargin: '0px 0px 600px 0px' });
        this.loadingObserver.observe(loading);
      }

      async loadMore() {
        const next = this.querySelector('[data-bm-next]');
        if (!next || this.loadingMore) return;
        this.loadingMore = true;
        const href = next.href;
        try {
          const url = new URL(href, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(String(response.status));
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...html.querySelectorAll('[data-bm-item]')].map((item) => document.importNode(item, true));
          this.querySelector('[data-bm-grid]')?.append(...items);
          const nextPage = html.querySelector('[data-bm-next]');
          if (nextPage) {
            next.href = nextPage.getAttribute('href');
          } else {
            this.loadingObserver?.disconnect();
            this.querySelector('[data-bm-loading]')?.remove();
            this.loadingTarget = null;
          }
        } catch (error) {
          window.location.assign(href);
          return;
        } finally {
          this.loadingMore = false;
        }

        /* Si la página nueva no alcanzó a sacar «CARGANDO...» de la vista, se pide la siguiente */
        const loading = this.querySelector('[data-bm-loading]');
        if (loading && loading.getBoundingClientRect().top < window.innerHeight + 600) this.loadMore();
      }

      /* Como en la PLP: el panel abre con los grupos sin filtros aplicados cerrados */
      onDrawerOpen(event) {
        if (event.target.id !== 'filters-drawer' || !this.contains(event.target)) return;
        if (!this.filtersOpen) {
          this.querySelectorAll('#filters-drawer details.facets__panel[open]').forEach((details) => {
            const active = [...details.querySelectorAll('input')].some((input) =>
              input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value !== ''
            );
            if (!active) details.open = false;
          });
        }
        this.filtersOpen = true;
      }

      onDrawerClose(event) {
        if (event.target.id === 'filters-drawer') this.filtersOpen = false;
      }

      /* El morph de Horizon cambia el <theme-drawer> por uno nuevo y cerrado: si estaba abierto se vuelve a abrir
         al instante, con los mismos grupos abiertos y el foco en el control que se tocó (igual que en la PLP) */
      keepFiltersOpen() {
        const drawer = this.querySelector('#filters-drawer');
        const panel = drawer?.querySelector('dialog');
        if (!this.filtersOpen || !panel || typeof drawer.open !== 'function') return;
        if (drawer.hasAttribute('open') && panel.open) return;

        if (this.filtersGroups) {
          drawer.querySelectorAll('details.facets__panel').forEach((details) => {
            details.open = this.filtersGroups.has(groupKey(details));
          });
        }
        const target = this.filtersFocus && document.getElementById(this.filtersFocus);
        this.querySelector('.bm-search__filter')?.focus({ preventScroll: true });
        drawer.removeAttribute('open');
        panel.classList.add('theme-drawer__dialog-instant');
        drawer.open();
        panel.classList.remove('theme-drawer__dialog--opening');
        requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove('theme-drawer__dialog-instant')));
        if (target && drawer.contains(target)) target.focus({ preventScroll: true });
      }

      onClick(event) {
        /* Clic en el velo propio del panel de filtros (≥ 990, bm-filters-drawer.css): cierra como el backdrop de Horizon */
        if (event.target.classList.contains('bm-search__facets')) {
          this.querySelector('#filters-drawer')?.close?.();
          return;
        }

        const viewButton = event.target.closest('[data-bm-view]');
        if (viewButton) {
          const view = viewButton.dataset.bmView;
          try {
            sessionStorage.setItem(VIEW_KEY, view);
          } catch (error) {}
          applyView(view);
          this.syncViews();
          return;
        }

        if (event.target.closest('[data-bm-sort-close]')) {
          this.setSortOpen(false);
          this.querySelector('[data-bm-sort-toggle]')?.focus();
          return;
        }

        const toggle = event.target.closest('[data-bm-sort-toggle]');
        if (toggle) {
          this.setSortOpen(toggle.getAttribute('aria-expanded') !== 'true');
          return;
        }

        /* El orden conserva el término, los filtros y type=product de la URL actual */
        const option = event.target.closest('[data-sort]');
        if (option) {
          event.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', option.dataset.sort);
          url.searchParams.set('type', 'product');
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const toggle = this.querySelector('[data-bm-sort-toggle]');
        if (toggle?.getAttribute('aria-expanded') === 'true') {
          event.stopPropagation();
          this.setSortOpen(false);
          toggle.focus();
        }
      }

      onDocumentClick(event) {
        if (!event.target.closest('[data-bm-sort]')) this.setSortOpen(false);
      }

      setSortOpen(open) {
        const toggle = this.querySelector('[data-bm-sort-toggle]');
        const list = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
        if (!toggle || !list) return;
        if (toggle.getAttribute('aria-expanded') === String(open)) return;
        toggle.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
        if (open) (list.querySelector('[aria-current]') || list.querySelector('a'))?.focus();
      }
    }

    customElements.define('bm-search', BmSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  /* Shop the look: el look abre su modal (dialog nativo). «SELECCIONAR TALLE» despliega las tallas; elegir una agrega
     esa variante (bm-quick-add.js la pasa al input «id») y, con el agregado confirmado, el modal se cierra y se abre
     el carrito con el producto (prototipo del Figma 24:3132: «Selector de talla» → «Carrito con producto»).
     Delegado en document: sobrevive al re-render de la sección en el editor. */
  if (!window.bmLooks) {
    window.bmLooks = true;

    /** @param {HTMLElement} toggle */
    const sizesOf = (toggle) => document.getElementById(toggle.getAttribute('aria-controls') || '');

    /**
     * @param {Element} root
     * @param {Element} [except]
     */
    const closeSizes = (root, except) => {
      root.querySelectorAll('[data-bm-look-sizes][aria-expanded="true"]').forEach((toggle) => {
        if (toggle === except || !(toggle instanceof HTMLElement)) return;
        toggle.setAttribute('aria-expanded', 'false');
        const list = sizesOf(toggle);
        if (list) list.hidden = true;
      });
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const opener = event.target.closest('[data-bm-look-open]');
      if (opener) {
        const dialog = document.getElementById(opener.getAttribute('aria-controls') || '');
        if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
        return;
      }

      const dialog = event.target.closest('dialog.bm-look');
      if (!(dialog instanceof HTMLDialogElement)) return;

      /* El contenido llena la ventana: un clic sobre el dialog mismo es el velo */
      if (event.target === dialog || event.target.closest('[data-bm-look-close]')) {
        dialog.close();
        return;
      }

      const toggle = event.target.closest('[data-bm-look-sizes]');
      if (toggle instanceof HTMLElement) {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        closeSizes(dialog, toggle);
        toggle.setAttribute('aria-expanded', String(open));
        const list = sizesOf(toggle);
        if (list) {
          list.hidden = !open;
          if (open) list.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
        }
        return;
      }

      if (!event.target.closest('.bm-look__sizes')) closeSizes(dialog);
    });

    /* Escape con las tallas abiertas: primero se cierran ellas (cancel no burbujea: va en captura) */
    document.addEventListener(
      'cancel',
      (event) => {
        const dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('bm-look')) return;
        const toggle = dialog.querySelector('[data-bm-look-sizes][aria-expanded="true"]');
        if (!(toggle instanceof HTMLElement)) return;
        event.preventDefault();
        closeSizes(dialog);
        toggle.focus();
      },
      true
    );

    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (dialog instanceof HTMLDialogElement && dialog.classList.contains('bm-look')) closeSizes(dialog);
      },
      true
    );

    /** @param {Event} event */
    const lookOf = (event) => (event.target instanceof Element ? event.target.closest('dialog.bm-look') : null);

    /* Antes se cerraba el modal al enviar y nada más: Horizon abre el carrito solo si «Abrir el carrito al agregar»
       está prendido (en este tema no), así que la talla se sumaba sin aviso y el look parecía no andar (QA Asana
       1219754643879528). Al elegir la talla se cierra el modal (el foco vuelve al look) y se abre el carrito lateral,
       o la página del carrito si el tema usa página, sin esperar la respuesta de /cart/add: esperarla demoraba la
       apertura (QA productos-03). El carrito se actualiza cuando Shopify contesta. */
    const openCart = () => {
      const drawer = /** @type {any} */ (document.getElementById('cart-drawer'));
      if (drawer && typeof drawer.open === 'function') {
        if (!drawer.isOpen) drawer.open();
        return;
      }
      /* global Theme: const de snippets/scripts (no cuelga de window) */
      const cartUrl = typeof Theme !== 'undefined' ? Theme.routes?.cart_url : '';
      window.location.assign(cartUrl || '/cart');
    };

    document.addEventListener('shopify:cart:lines-update', (event) => {
      const dialog = lookOf(event);
      if (!(dialog instanceof HTMLDialogElement) || /** @type {any} */ (event).action !== 'add') return;
      dialog.querySelectorAll('[data-bm-look-error]').forEach((error) => {
        if (error instanceof HTMLElement) error.hidden = true;
      });
      if (!dialog.open) {
        openCart();
        return;
      }
      dialog.addEventListener('close', openCart, { once: true });
      dialog.close();
    });

    /* Rechazo (p. ej. no queda más stock de esa talla): se cierran las tallas, el foco vuelve a «SELECCIONAR TALLE» y el
       motivo de Shopify queda debajo */
    document.addEventListener('shopify:cart:error', (event) => {
      const dialog = lookOf(event);
      const info = event.target instanceof Element ? event.target.closest('.bm-look__info') : null;
      const error = info?.querySelector('[data-bm-look-error]');
      if (!(dialog instanceof HTMLDialogElement) || !(error instanceof HTMLElement)) return;
      const { detail } = /** @type {any} */ (event);
      closeSizes(dialog);
      const toggle = info?.querySelector('[data-bm-look-sizes]');
      if (toggle instanceof HTMLElement) toggle.focus({ preventScroll: true });
      error.textContent = detail?.description || /** @type {any} */ (event).error || '';
      error.hidden = !error.textContent;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
